import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';
import FONTS_FAMILY from '../../../theme/FontsFamily';

import BackgroundPrimary from '../../../assets/images/BackgroundPrimary.png';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  height: '100vh',
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  boxShadow: 'inset 0 0 0 6000px rgba(0,0,0,.5)',
});

export const RightContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'flex-end',
  height: '100%',
  backgroundColor: COLORS.white,
  position: 'relative',
  width: '100%',
  overflow: 'auto',
  'h1,h2,h3,p': {
    color: COLORS.black,
    margin: 4,
  },
});

export const LeftContainer = styled('div')({
  height: 'auto',
  justifyContent: 'center',
  alignItems: 'center',
  //  backgroundColor: COLORS.primary,
  width: '100%',
  backgroundImage: `url(${BackgroundPrimary})`,
  '@media (min-width:320px)': {
    display: 'none',
  },
  '@media (min-width:768px)': {
    display: 'none',
  },
  '@media (min-width:1024px)': {
    display: 'flex',
  },
});

export const FormContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '700px',
  maxWidth: '800px',
  width: '90%',
  alignSelf: 'center',
  marginTop: '30px',
  'h1,h2,h3,p': {
    marginLeft:0,
    color: COLORS.black,
  },
  h1: {
    letterSpacing: 2,
    fontWeight: 300,
  },
});

export const LogoImg = styled('img')({
  objectFit: 'contain',
  width:'512px',
  height: 'auto',
  filter: 'brightness(0) invert(1)',
});

export const FoundationImg = styled('img')({
  width: '147px',
  aspectRatio: '3/2',
  objectFit: 'contain',
  alignSelf: 'center',
});

export const SuccessMessage = styled('h4')({
  color: COLORS.primary,
  fontSize: '0.8em',
  fontWeight: 300,
});

export const SuccessTitle = styled('h1')({
  color: '#656565 !important',
  // letterSpacing: `0 !important`,
  textAlign: 'center',
  fontSize: '1.5em',
  fontWeight: 300,
});
export const SuccessBody = styled('p')({
  color: '#656565',
  fontSize: '0.6em',
  fontWeight: 300,
});
